const Titulo = ({ children }) => {
    return (
        <div className="blanco elige">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Titulo;